<template>
    <v-card>
        <v-form ref="form" v-model="formValid" :lazy-validation="true">
            <v-card-title>DMS Conversion</v-card-title>
            <v-card-text>
                <v-row dense no-gutters>
                    <v-col cols="12">
                        <v-text-field label="Degrees" type="number" color="#c42111" v-model="dmsDegrees" outlined :rules="[validation.required(dmsDegrees)]" />
                    </v-col>
                    <v-col cols="12">
                        <v-text-field label="Minutes" type="number" color="#c42111" v-model="dmsMinutes" outlined :rules="[validation.required(dmsDegrees)]" />
                    </v-col>
                    <v-col cols="12">
                        <v-text-field label="Seconds" type="number" color="#c42111" v-model="dmsSeconds" outlined :rules="[validation.required(dmsDegrees)]" />
                    </v-col>
                    <v-col cols="12">
                        <v-radio-group v-model="dmsType" row dense :rules="[validation.required(dmsType)]">
                            <v-radio label="N" value="north" color="#c42111" v-if="$props.lat"></v-radio>
                            <v-radio label="S" value="south" color="#c42111" v-if="$props.lat"></v-radio>
                            <v-radio label="E" value="east" color="#c42111" v-if="!$props.lat"></v-radio>
                            <v-radio label="W" value="west" color="#c42111" v-if="!$props.lat"></v-radio>
                        </v-radio-group>
                    </v-col>
                </v-row>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
                <div class="flex-grow-1"></div>
                <v-btn text class="mr-3" @click="$emit('close')">Cancel</v-btn>
                <v-btn text class="ml-3 mr-3" @click="calculate">Ok</v-btn>
            </v-card-actions>
        </v-form>
    </v-card>
</template>

<script>
export default {
  name: 'DmsConvert',
  props: ['lat'],
  components: {

  },
  data: () => ({
    dmsDegrees: '',
    dmsMinutes: '',
    dmsSeconds: '',
    dmsType: '',
    formValid: true,
    validation: {
        required: (value) => (value ? true : false || "Required field")
    }
  }),

  computed: {
    
  },

  methods: {
    calculate: function() {
        if(this.$refs.form.validate()) {
            let ans = Number(this.dmsDegrees) + (Number(this.dmsMinutes) / 60) + (Number(this.dmsSeconds) / 3600);
            if(this.dmsType == 'south' || this.dmsType == 'west') {
                ans = (-1 * ans);
            }
            ans = ans.toFixed(7);
            this.$emit('set', ans);
        }
    }

  },

  mounted() {

  }

  
};
</script>
